import {CONSIGNMENT_OPPORTUNITY} from "../item/opportunity-record-type.const";

export class Opportunity {
  opportunityId: string;
  opportunityName: string;
  opportunityGUID: string;
  contractGUID: string;
  contractId: string;
  contractNumber: string;
  createdAt: string;
  updatedAt: string;

  acgGUID: string;
  rbCustNumber: string;
  auctionEventGUID: string;
  contractRecordType: string;
  opportunityRecordType: string;

  legalAccountName: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  mobileNumber: string;
  faxNumber: string;
  email: string;
  address: string;
  city: string;
  stateProvince: string;
  postalCode: string;
  county: string;
  country: string;
  currencyCode: string;
  opportunityStage: string;
  opportunityStageModifiedDate: string;
  contractDocumentStatus: string;

  sellerId: number;

  sellerContractId: number;

  auctionEventId: number;

  ipOpportunityId: number;

  acgOwnerId: number;

  createdDt: Date;

  modifiedDt: Date;

  stageModifiedDt: Date;

  acgStatus: string;

  acgStatusId: number;

  acgId: number;

  packageType: number;
  contractSigned: boolean;
  contractState: string;
  operationEntityCountryCode:string;
  hasChannelSaleMismatch: boolean;
  contractChannel: string;

  public isConsignmentOpportunity() : boolean {
    return CONSIGNMENT_OPPORTUNITY === this.opportunityRecordType;
  }

}
